import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig, { FetchMethod } from '../useGetFetchConfig';

interface UseUpdateOrganisationBillingPeriod {
  maxCredits?: number;
  billingStartDate: Date;
  billingEndDate: Date;
  seatCount?: number;
  defaultCreditLimit?: number;
}

export const useUpdateOrganisationBillingPeriod = (orgId: string) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: UseUpdateOrganisationBillingPeriod) => {
      const fetchConfig = getFetchConfig({ method: FetchMethod.PATCH, data });
      const response = await fetch(`${APIBaseChronos}/api/org/${orgId}/billing-period`, fetchConfig);
      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.message || 'Failed to update billing period');
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries([QueryEntity.OrganisationById, { orgId }]);
      queryClient.invalidateQueries([QueryEntity.OrganisationBillingPlanHistory, { orgId }]);
      toast.success('Billing period successfully updated');
    },
    onError: (error: Error) => {
      toast.error(error.message);
    },
  });
};
